import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from '../../../../../../common/react/components/SvgIcon';
import { ImageElement } from './image';

const VARIANT_CONFIG = [
    {
        name: 'thumbnailMobile',
        maxWidth: 640,
        size: { width: 120 },
        multipliers: [1, 2, 3]
    },
    {
        name: 'thumbnailDesktop',
        minWidth: 641,
        size: { width: 160 },
        multipliers: [1, 2, 3]
    },
    {
        name: 'default',
        size: { width: 160 },
        multipliers: [1]
    }
];

export const MediaThumbnail = ({ video }) => {
    const ref = useRef();
    const videoData = PULSE.app.common.content.getContentModel(
        video,
        VARIANT_CONFIG
    );
    const videoModalData = {
        contentId: video.id,
        mediaId: video.mediaId,
        mediaTitle: video.title,
        mediaDescription: video.description,
        subtitle: video.subtitle,
        type: video.type,
        link: video.hotlinkUrl,
        publishFrom: video.publishFrom + 1
    };

    useEffect(() => {
        if (ref.current) {
            PULSE.app.VideoPlayerModal.createInstance(ref.current);
        }
    }, []);
    return (
        <article className={`media-thumbnail`}>
            <div className="media-thumbnail__link">
                <a
                    ref={ref}
                    className={`media-thumbnail__absolute-link`}
                    href={videoData.link}
                    title={video.title}
                    data-ui-modal="#VideoModal"
                    data-modal-added="true"
                    data-ui-args={JSON.stringify(videoModalData)}
                ></a>
                <header
                    className={`media-thumbnail__image-container placeholder placeholder--small placeholder--dark`}
                >
                    <div className="js-lazy-load lazy-image-wrapper is-loaded">
                        <ImageElement
                            ImageUrl={video.onDemandUrl}
                            ImageTitle={video.title}
                        />
                    </div>

                    <div className={`media-thumbnail__video-duration`}>
                        <SvgIcon
                            icon={'video-play-small'}
                            className={`icon media-thumbnail__duration-icon`}
                        />
                        <span className={`media-thumbnail__duration-text`}>
                            {PULSE.app.common.date.durationToTime(
                                video.duration
                            )}
                        </span>
                    </div>
                </header>
                <div className={`media-thumbnail__caption`}>
                    <h2 className={`media-thumbnail__title`}>{video.title}</h2>
                </div>
            </div>
        </article>
    );
};

MediaThumbnail.propTypes = {
    video: PropTypes.object
};
